import React, { useEffect } from "react";
import { withTranslation } from "react-i18next";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  IconButton,
  Grid,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";
import Backdrop from "Components/Common/Backdrop";
import { DialogHeader } from "./style";
import CGRFApplicationDetailsView from "./CGRFApplicationDetailsView";
import { useGetAllCGRFGrievanceData } from "apis/CGRFGiftPCL";
import CGRFComplainDetailsView from "./CGRFComplainDetailsView";
import NomineeDetailsView from "./NomineeDetailsView";
import CGRFDocumentsViewModal from "./CGRFDocumentsViewModal";

const CGRFApplicationViewModal = ({ handleClose, applicationId, t }) => {
  const {
    data: { data: applicationData = {} } = {},
    isLoading: isApplicationDataLoading,
    isFetching,
    isError,
  } = useGetAllCGRFGrievanceData(applicationId);

  useEffect(() => {
    if (isError) {
      handleClose();
    }
  }, [isError]);

  if (isApplicationDataLoading || isFetching) {
    return <Backdrop open />;
  }

  return (
    <Dialog
      open={!!applicationId}
      onClose={handleClose}
      maxWidth="xl"
      fullWidth
      scroll="paper"
    >
      <DialogHeader>
        {t("Grievance Details")}
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogHeader>
      <DialogContent>
        <DialogContentText variant="subtitle2" component="div">
          <div className="mt-2 ">
            {!!applicationData && (
              <>
                <CGRFApplicationDetailsView applicationData={applicationData} />
                <CGRFComplainDetailsView applicationData={applicationData} />
                <NomineeDetailsView applicationData={applicationData} />
                <CGRFDocumentsViewModal
                  documents={applicationData?.grievanceDocuments}
                />
              </>
            )}
          </div>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

CGRFApplicationViewModal.propTypes = {
  handleClose: PropTypes.func,
  applicationId: PropTypes.string,
  t: PropTypes.func,
};

export default withTranslation()(CGRFApplicationViewModal);
